<ng-container>
  <header class="header" *ngIf="realtor$ | async as realtorData">
    <div class="header-info">
      <div [style.backgroundColor]="realtorData.headerColor" class="header-info-top">
        <div class="header-info-headers">
          <h3 [ngStyle]="{fontSize:fontSize}">
            {{ realtorData.firstName }} {{ realtorData.lastName }}</h3>
          <div class="dot">&middot;</div>
          <h3 [ngStyle]="{fontSize:fontSize}">
            {{ realtorData.companyName }}</h3>
        </div>
      </div>
    </div>
    <div class="header-logo">
      <div class="header-logo-img">
        <div class="img-container"
          [ngStyle]="{'background-image': 'url(' + realtorData.companyLogoUrl + ')','background-size': 'contain','max-width':'96pt'}">
        </div>

        <!-- <img *ngIf="realtorData.companyLogoUrl" [src]="realtorData.companyLogoUrl" alt="Real Estate Partners"> -->
      </div>
    </div>
  </header>
  <table *ngIf="rePosition(borrower$ | async) as borrowerData" class="supporting-docs-table">
    <thead>
      <tr>
        <td>
          <div class="header-space">&nbsp;</div>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <main>
            <ng-container *ngFor="let asset of borrowerData.preApprovalAssets">
              <ng-container *ngIf="asset.fileUrl && isShowLetter(asset, borrowerData.isCustom)">
                <section *ngFor="let file of asset.files" class="documents-section" [ngStyle]="{'display': isNotPdf(file.url) ? 'block': 'none' }">
                  <ng-container *ngIf="isNotPdf(file.url)">
                    <!--<h2>{{ asset.assetTypeId == 7 || asset.assetTypeId == 6 ? '': 'Supporting Documents' }} </h2>-->
                    <!-- <h5 *ngIf="asset.assetTypeId != 7">{{ asset.alternateName != '' && asset.alternateName != null ? asset.alternateName : asset.assetTypeName }}</h5>
                    <h5 *ngIf="asset.assetTypeId == 7">Pre-Approval Letter</h5> -->
                    <div class="document-wrapper" >
                      <img [src]="file.url" alt="{{ file.name }}">
                    </div>
                  </ng-container>
                </section>
              </ng-container>
            </ng-container> 
            <!-- <ng-container *ngFor="let asset of borrowerData.preApprovalAssets">
              <ng-container *ngIf="asset.fileUrl && isShowLetter(asset, borrowerData.isCustom)">
                <section *ngFor="let file of asset.files" class="documents-section">
                  <h2>Supporting Documents</h2>
                  <h5>{{ asset.alternateName != '' && asset.alternateName != null ? asset.alternateName : asset.assetTypeName }}</h5>
                  <div class="document-wrapper">
                    <img [src]="file.url" alt="{{ file.name }}">
                  </div>
                </section>
              </ng-container>
            </ng-container> -->
          </main>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td>
          <div class="footer-space">&nbsp;</div>
        </td>
      </tr>
    </tfoot>
  </table>

  <footer *ngIf="realtor$ | async as realtorDataFooter" [style.backgroundColor]="realtorDataFooter.footerColor"
    class="footer">
    <ul class="footer-info">
      <li>
        {{ realtorDataFooter.firstName }} {{ realtorDataFooter.lastName }}, {{ realtorDataFooter.phoneNumber }},
        <a href="mailto:{{ realtorDataFooter.email }}">{{ realtorDataFooter.email }}</a>
      </li>
      <li *ngIf="realtorDataFooter.officeAddress">{{ realtorDataFooter.officeAddress }}</li>
      <li *ngIf="realtorDataFooter.website"><a href="{{ realtorDataFooter.website }}">{{ realtorDataFooter.website }}</a></li>
    </ul>
  </footer>
</ng-container>